var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.23818447 7.7984593V.44971893C8.23818447.19987508 8.03830939 0 7.78846554 0s-.44971892.19987508-.44971892.44971893V7.7984593c-1.04268166.20986883-1.83218822 1.13262544-1.83218822 2.2386009 0 1.1059754.78950656 2.028732 1.83218822 2.2386008v3.2712888c0 .2498439.19987507.4497189.44971892.4497189.24984385 0 .44971893-.199875.44971893-.4497189V12.275661c1.04268166-.2098688 1.83218823-1.1326254 1.83218823-2.2386008 0-1.10264421-.78617532-2.02873207-1.83218823-2.2386009zm-5.5065584-3.77097648V.44971892C2.73162607.19987509 2.53175099 0 2.28190714 0s-.44971892.19987508-.44971892.44971893v3.57776389C.78950656 4.23735166 0 5.16010827 0 6.2660837s.78950656 2.02873204 1.83218822 2.23860087v7.04226523c0 .2498439.19987507.4497189.44971892.4497189.24984385 0 .44971893-.199875.44971893-.4497189V8.50135332c1.04268165-.20986883 1.83218821-1.13262544 1.83218821-2.23860087 0-1.10597544-.78950656-2.02540079-1.83218821-2.23526963zm10.97980433 0V.44971892C13.7114304.19987509 13.5115553 0 13.2617114 0c-.2498438 0-.4497189.19987508-.4497189.44971893v3.57776389c-1.0426817.20986884-1.8321882 1.13262545-1.8321882 2.23860088s.7895065 2.02873204 1.8321882 2.23860087v7.04559653c0 .2498438.1998751.4497189.4497189.4497189.2498439 0 .449719-.1998751.449719-.4497189V8.50135332c1.0426816-.20986883 1.8321882-1.13262544 1.8321882-2.23860087 0-1.10597544-.7861753-2.02540079-1.8321882-2.23526963z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#C1CEDE",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#71B8CB",
    xlinkHref: "#a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.ebc68def4ddcdfa7537964c28fdbb6c9.svg";
export { ForwardRef as ReactComponent };